import ApplicationForm from "Portal/ApplicationForm/View";

const ApplicationFormRoutes = {
  ApplicationForm,
  ApplicationFormLogin: ApplicationForm,
  ApplicationFormCallback: ApplicationForm
};

export default ApplicationFormRoutes;
